import styleText from '../../../../shared/components/rbh-text/styles';
import { Colors } from '../../../../shared/theme/';
import metrics from '../../../../shared/theme/metrics';

export default {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: metrics.baseMargin + 4,
  } as React.CSSProperties,
  subTitleText: {
    ...styleText.textRegular14,
    color: Colors.font.primary.darkGray,
    marginBottom: metrics.base * 2
  }
};
